import Circles from '@vx/pattern/build/patterns/Circles';
import Hexagons from '@vx/pattern/build/patterns/Hexagons';
import Lines from '@vx/pattern/build/patterns/Lines';
import Waves from '@vx/pattern/build/patterns/Waves';
export var PatternCircles = Circles;
export var PatternHexagons = Hexagons;
export var PatternLines = Lines;
export var PatternWaves = Waves;